import { Navigate, useLocation } from "react-router";

export default function PreEntry() {
  const { state } = useLocation();

  if (!state?.redirected) {
    return <Navigate to="/" />;
  }

  return (
    <div className="card mx-auto w-full max-w-lg px-4 py-8 text-center">
      <h1 className="text-red mb-4 font-bold">Sorry</h1>
      <h2 className="text-red mx-auto max-w-xs text-center font-bold">
        This promotion has not started yet.
      </h2>
    </div>
  );
}
